<template>
	<v-container fluid class="py-0">
		<div>{{ label }}</div>
		<v-row>
			<v-col cols="auto" class="py-0 grow">
			  	<v-range-slider 
			  	class="align-center" 
			  	hide-details
			  	outlined
			  	:tick-size="1"
			  	:value="array_value"
			  	:max="max"
            	:min="min"
            	:step="step"
            	:ticks="true"
			  	@change="onInput"
			  	@input="trackChanges"
			  	>
			    <template v-slot:prepend>
			      	<div style="width: 60px">{{ min_value_display }}</div>
			    </template>
			    <template v-slot:append>
			      	<div class="text-right" style="width: 60px">{{ max_value_display }}, {{ trans('advert.price_currency_usd') }}</div>
			    </template>
			  </v-range-slider>
			</v-col>
			<!-- <v-col cols="auto" class="py-0 shrink">
				
			</v-col> -->
		</v-row>
	</v-container>
</template>

<script>
	import _ from 'lodash';
	export default {
		props: [
			'label',
			'value',
			'max',
			'min',
			'step',
		],

		data: () => ({
			buffer: [0,100]
		}),

		mounted: function() {
			this.buffer = _.toArray(this.value);
		},

		methods: {
			onInput: function(value) {
				this.buffer = value;
				let payload = {};
				let min = Math.min(...value);
				let max = Math.max(...value);
				if (min != this.$props.min && min != 0) {
					payload.min = min;
				}
				if (max != this.$props.max && max != 0) {
					payload.max = max;
				}
				this.$emit('input', payload);
				/*
				if (_.isEqual(value, [this.$props.min, this.$props.max])) {
					this.$emit('input', null);
				} else {
					this.$emit('input', payload);
				}*/
			},
			trackChanges: function(value) {
				this.buffer = value;
			}
		},

		computed: {
			array_value: function() {
				let val = _.toArray(this.value);
				this.buffer = val;
				return val
			},
			min_value_display: function() {
				return _.min(this.buffer);
			},
			max_value_display: function() {
				return _.max(this.buffer);
			},	
		}
	}
</script>